import { SocketIoConfig } from 'ngx-socket-io';

export const environment = {
  mainServer: 'https://test.veggly.net',
  mainUrlWeb: 'https://veggly-v3-dev.web.app',
  //mainServer: 'http://localhost:8080',
  imgServer: 'https://test.veggly.net',
  //socketServer: 'test.veggly.net',
  socketServer: 'test.veggly.net',
  production: false,
  requestTimeout: 30000,
  priceVegBoost: 5,
  priceSuperLike: 1,
  locationDefault: { type: 'Point', coordinates: [-0.118092, 51.509865] },
  googleAuth: {
    ios: '487315392129-m14fvrs0cpoicpn89musij6ndjkimcg4.apps.googleusercontent.com',
    // There seems to be a bug with the android client id, so we are using the web client id
    android: '487315392129-2hvpfarl7npvmmlkai1q7bc69a96oj6k.apps.googleusercontent.com',
    web: '487315392129-2hvpfarl7npvmmlkai1q7bc69a96oj6k.apps.googleusercontent.com',
  },
  mapbox: {
    token: 'pk.eyJ1IjoiYW5kcmVwYWl2YSIsImEiOiJjbWkzMWZ3emoxZmkyMmpwd3ZuazNyY2ltIn0.QJITkWgCFsXWLWnKqZbpmg',
  },
  products: {
    oneCoin: {
      id: '1coin',
      alias: '1 Coin',
      price: '$2.00 USD',
      priceNumber: 2.00,
      priceMicros: 1 * 1000 * 1000,
      priceSet: false,
      priceMicrosSet: false,
    },
    tenCoin: {
      id: '10coins',
      alias: '10 Coins',
      price: '$8.00 USD',
      priceNumber: 8.00,
      priceMicros: 8 * 1000 * 1000,
      priceSet: false,
      priceMicrosSet: false,
    },
    fiftyCoin: {
      id: '50coins',
      alias: '50 Coins',
      price: '$25.00 USD',
      priceNumber: 25.00,
      priceMicros: 25 * 1000 * 1000,
      priceSet: false,
      priceMicrosSet: false,
    },
    hundredCoin: {
      id: '100coins',
      alias: '100 Coins',
      price: '$40.00 USD',
      priceNumber: 40.00,
      priceMicros: 40 * 1000 * 1000,
      priceSet: false,
      priceMicrosSet: false,
    },
    vegglylight: {
      id: 'vegglylight',
      name: 'Veggly Light',
      price: '$1.50 USD',
      priceNumber: 1.50,
    },
    vegglyplus: {
      id: 'vegglyplus',
      name: 'Veggly Plus',
      price: '$3.00 USD',
      priceNumber: 3.00,
    },
    vegglyunique: {
      id: 'vegglyunique',
      name: 'Veggly Unique',
      price: '$4.00 USD',
      priceNumber: 4.00,
    },
    vegglypremium: {
      id: 'vegglypremium',
      name: 'Avocado Club',
      price: '$10.00 USD',
      priceNumber: 10.00,
      priceMicros: 5 * 1000 * 1000,
      priceSet: false,
      priceMicrosSet: false,
    },
    vegglypremium3months: {
      id: 'vegglypremium3months',
      name: 'Avocado Club 3 Months',
      price: '$24.00 USD',
      priceNumber: 24.00,
      priceMicros: 12 * 1000 * 1000,
      priceSet: false,
      priceMicrosSet: false,
      discount: 20,
    },
    vegglypremium6months: {
      id: 'vegglypremium6months',
      name: 'Avocado Club 6 Months',
      price: '$42.00 USD',
      priceNumber: 42.00,
      priceMicros: 21 * 1000 * 1000,
      priceSet: false,
      priceMicrosSet: false,
      discount: 30,
    },
    vegglypremium12months: {
      id: 'vegglypremium12months',
      name: 'Avocado Club 12 Months',
      price: '$67.00 USD',
      priceNumber: 67.00,
      priceMicros: 33.6 * 1000 * 1000,
      priceSet: false,
      priceMicrosSet: false,
      discount: 44,
    },
    club: {
      id: 'avocado_club',
      name: 'Avocado Club',
      price: '$12.00 USD',
      priceMicros: 5 * 1000 * 1000,
      priceSet: false,
      priceMicrosSet: false,
    },
    club_3_months: {
      id: 'avocado_club_3_months',
      name: 'Avocado Club 3 Months',
      price: '$27.00 USD',
      priceMicros: 12 * 1000 * 1000,
      priceSet: false,
      priceMicrosSet: false,
      discount: 20,
    },
    club_6_months: {
      id: 'avocado_club_6_months',
      name: 'Avocado Club 6 Months',
      price: '$52.00 USD',
      priceMicros: 21 * 1000 * 1000,
      priceSet: false,
      priceMicrosSet: false,
      discount: 30,
    },
    club_12_months: {
      id: 'avocado_club_12_months',
      name: 'Avocado Club 12 Months',
      price: '$87.00 USD',
      priceMicros: 33.6 * 1000 * 1000,
      priceSet: false,
      priceMicrosSet: false,
      discount: 44,
    },
    club_30percent_off: {
      id: 'avocado_club_30percent_off',
      name: 'Avocado Club 30% Off',
      price: '$8.40 USD',
      priceMicros: 8.4 * 1000 * 1000,
      priceSet: false,
      priceMicrosSet: false,
      discount: 30,
    },
    productCurrency: 'BRL',
    tenCoinDiscount: 20,
    fiftyCoinDiscount: 50,
    hundredCoinDiscount: 60,
    urlValidator: "https://validator.iaptic.com/v1/validate?appName=veggly&apiKey=b015baa0-f92e-4a26-b79a-34935be28205"
  },
  adjustDownloadLink: 'https://app.adjust.com/106z1xo9',
  adjustAppToken: 'i2t6o8igsjk0',
  /**
   * TikTok App Events SDK credentials from Events Manager (per OS).
   * Each platform needs its own TikTok App ID + Access Token.
   */
  tiktok: {
    ios: {
      appId: 'TODO_TIKTOK_IOS_APP_ID',
      tiktokAppId: 'TODO_TIKTOK_IOS_TIKTOK_APP_ID',
      accessToken: 'TODO_TIKTOK_IOS_ACCESS_TOKEN'
    },
    android: {
      appId: 'com.veggly',
      tiktokAppId: 'TODO_TIKTOK_ANDROID_APP_ID',
      accessToken: 'TODO_TIKTOK_ANDROID_ACCESS_TOKEN'
    }
  },
  /**
   * Direct PostHog ingest for local/e2e. Production builds replace this
   * file with environment.prod.ts (first-party proxy).
   */
  posthog: {
    apiKey: 'phc_pKaN9zMFtMXqpwhTGzWkascxeeoBwduhYm6L2uyCbSAx',
    apiHost: 'https://us.i.posthog.com',
    uiHost: 'https://us.posthog.com',
    appName: 'veggly'
  }
};

export const webVersion: string = 'web-3.6.3';

export const configSocketIO: SocketIoConfig = {
  url: 'wss://' + environment.socketServer + '/',
  options: {}
};
